/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
	baseUrl: 'https://hasty-tasty.com',
	baseApiUrl: 'https://api.hasty-tasty.net/api',
	// baseApiUrl: 'https://hastytastyapi.azurewebsites.net/api',
	baseOrderUrl: 'https://api.hasty-tasty.net',
	baseIdentityApiUrl: 'https://identity.hasty-tasty.net/api',
	baseSignalRUrl: 'https://api.hasty-tasty.net',
	production: true,
	clientId: 'oidcClient',
	postLogoutRedirectUri: 'https://hasty-tasty.com/auth',
	silentRedirectUri: 'https://hasty-tasty.com/assets/silent-refresh.html',
	authority: 'https://identity.hasty-tasty.net/',
	redirectUri: 'https://hasty-tasty.com/auth-callback',
	encryptSecret: 'secret'
};
